<div
  [class.no-left-padding]="noLeftPadding"
  class="input-container"
  #durationDropdownTrigger="rtOverlayOrigin"
  rt-overlay-origin
  layout-horizontal
  layout-align-items-center
>
  @if (currentDuration.length) {
    <div class="input-mask" (click)="toggleDropdown(durationDropdown)">
      {{ currentDuration }} {{ 'app.interview.schedule_dialog.minutes' | translate }}
    </div>
  }
  <rt-input
    [formControl]="durationControl"
    [placeholder]="'app.interview.schedule_dialog.duration_placeholder' | translate"
    [class.dropdownOpened]="durationDropdown.open"
    [hasDropdownIndicator]="true"
    [invalid]="invalid"
    (keydown)="onKeyDown($event)"
    (valueChange)="onInputChange($event)"
    (click)="toggleDropdown(durationDropdown)"
    type="number"
  />
</div>
<ng-template
  #durationDropdown="rtConnectedOverlay"
  rt-connected-overlay
  hasBackdrop
  [origin]="durationDropdownTrigger"
  [width]="dropdownWidth"
  (backdropClick)="closeDropdown(durationDropdown)"
>
  <rt-time-picker-dropdown
    [currentSelected]="currentDuration"
    [durationMin]="5"
    [durationMax]="300"
    [duration]="true"
    (timeSelect)="onDurationChange($event); closeDropdown(durationDropdown)"
  />
</ng-template>
